const inFlightRequests = new Map();
const resolvedCache = new Map();

function isFresh(entry) {
  return entry && entry.expiresAt > Date.now();
}

function cloneIfNeeded(value) {
  if (value && typeof value.clone === 'function') {
    return value.clone();
  }

  return value;
}

export function readCachedValue(cacheKey) {
  const entry = resolvedCache.get(cacheKey);
  if (!isFresh(entry)) {
    resolvedCache.delete(cacheKey);
    return null;
  }

  return entry.value;
}

export function clearCachedValue(cacheKey) {
  resolvedCache.delete(cacheKey);
  inFlightRequests.delete(cacheKey);
}

export function runCachedRequest(cacheKey, requestFactory, options = {}) {
  const { ttl = 0, force = false } = options;

  if (!force) {
    const cachedValue = readCachedValue(cacheKey);
    if (cachedValue !== null) {
      return Promise.resolve(cloneIfNeeded(cachedValue));
    }
  }

  if (inFlightRequests.has(cacheKey)) {
    return inFlightRequests.get(cacheKey).then((value) => cloneIfNeeded(value));
  }

  const requestPromise = Promise.resolve()
    .then(() => requestFactory())
    .then((value) => {
      const cacheValue = cloneIfNeeded(value);

      if (ttl > 0) {
        resolvedCache.set(cacheKey, {
          value: cacheValue,
          expiresAt: Date.now() + ttl,
        });
      } else {
        resolvedCache.delete(cacheKey);
      }

      return cacheValue;
    })
    .finally(() => {
      inFlightRequests.delete(cacheKey);
    });

  inFlightRequests.set(cacheKey, requestPromise);
  return requestPromise.then((value) => cloneIfNeeded(value));
}
